<template>
  <VScaleScreen width="1920" height="1080" :box-style="boxStyle()" bodyOverflowHidden>
    <Index></Index>
  </VScaleScreen>
</template>

<script setup>
import VScaleScreen from "v-scale-screen";
import Index from "./views/index.vue"

const boxStyle = () => {
  const url = new URL("./assets/image/bg.png", import.meta.url).href;
  return { background: `url(${url}) ` };
};
</script>

<style>
* {
  margin: 0;
}
</style>
